<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="关联单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getAccountFlowListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAccountFlowListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="变动类型：">
                <el-select v-model="searchForm.flowType" clearable>
                    <el-option label="入账" value="1"></el-option>
                    <el-option label="出账" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAccountFlowListHandler" plain icon="el-icon-search">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> 
            <el-table-column label="ICCID号" width="180" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column label="关联单号" width="220" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)"
                    v-if="scope.row.orderNo.indexOf('JD')==0 ||
                    scope.row.orderNo.indexOf('WX')==0 ||
                    scope.row.orderNo.indexOf('YE')==0 ||
                    scope.row.orderNo.indexOf('LS')==0 " 
                    @click="jumpByOrderNo(scope.row.orderNo)">{{ scope.row.orderNo }}</a>

                    <span v-else>{{ scope.row.orderNo }}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="mobile" label="手机号" width="180" align="center"></el-table-column>
            <el-table-column  prop="amount" label="变动金额（元）" width="120" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.flowType == 1" style="color: green;">+{{ scope.row.amount/100 }}</span>
                    <span v-if="scope.row.flowType == 2" style="color: red;">-{{ scope.row.amount/100 }}</span>
                </template>
            </el-table-column>

            <el-table-column  label="变动类型" width="100" align="center">
                <template slot-scope="scope">
                	<span v-if="scope.row.flowType == 1" style="color: green;">入账</span>
                    <span v-if="scope.row.flowType == 2" style="color: red;">出账</span>
                </template>
            </el-table-column>
            <el-table-column  label="变动时间" width="180" align="center">
                <template slot-scope="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.createTime))}}
                </template>
            </el-table-column>
            <el-table-column  prop="remark" label="备注" align="center"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

                 
    </div>
</template>
<script>
import { getAccountFlowRecordList, getUserBalance} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                orderNo: '',
                payState:null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {

        getAccountFlowListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getAccountFlowRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })   

        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },


        jumpByOrderNo(orderNo){
            //余额支付则跳转到订单管理
            if(orderNo.indexOf("YE")==0){
                this.$store.commit('menu/setFromPage', 'userAccountFlowRecord');
                this.$store.commit('menu/setToOrderMgtOrderNo', orderNo);
                document.getElementById('orderMgtMenu').click();
            }
            //微信、京东支付跳转充值记录
            else if(orderNo.indexOf("WX")==0 || orderNo.indexOf("JD")==0 || orderNo.indexOf("LS")==0){
                this.$store.commit('menu/setFromPage', 'userAccountFlowRecord');
                this.$store.commit('menu/setFromPageOrderNo', orderNo);
                document.getElementById('balanceRechargeRecordMenu').click();
            }
            
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountFlowListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAccountFlowListHandler();
        }  
    },
    created () {
        this.getAccountFlowListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

